// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { node } from 'prop-types';
import styled from '@emotion/styled';
import { Loading } from '@carbon/react';
import { useContextSelector } from 'use-context-selector';

import { StyledOverlay as Overlay } from 'Components/Products/Products';
import { ProductsContext } from 'Contexts/ProductsContext';
import { FiltersContext } from 'Contexts/FiltersContext';

const StyledProductsPage = styled.div`
  position: relative;

  &.withTitle {
    .productsContainer {
      margin-top: 20px;
    }
  }

  .productsContainer {
    display: flex;
    margin-top: -1rem;
  }
`;

const StyledOverlay = styled(Overlay)`
  .cds--loading {
    width: 2rem;
    height: 2rem;
    position: sticky;
    left: 50%;
    top: 50%;
    z-index: 99;
  }
`;

const ViewProductsPage = memo(({ children }) => {
  const isLoading = useContextSelector(ProductsContext, ({ isLoading: loading }) => loading);
  const activeFilters = useContextSelector(FiltersContext, data => data.activeFilters);
  return (
    <StyledProductsPage
      className={ `${ isLoading ? 'loading' : '' } ${ activeFilters?.category?.name ? 'withTitle' : '' } grid-container` }
    >
      <StyledOverlay className="overlay grid-container" open={ isLoading }>
        { isLoading && (<Loading active withOverlay={ false } small />) }
      </StyledOverlay>
      <div className="productsContainer">
        { children }
      </div>
    </StyledProductsPage>
  );
});

ViewProductsPage.propTypes = {
  children: node
};
ViewProductsPage.displayName = 'ViewProductsPageComponent';

export default ViewProductsPage;
